"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
const locales_1 = tslib_1.__importDefault(require("./locales"));
const __sfc_main = {};
__sfc_main.props = ['actSign', 'listLeftTitle', 'listRightTitle', 'backgroundColor', 'bgBorderColor', 'lineColor', 'bgBorderRadius'];
__sfc_main.setup = (__props, __ctx) => {
    /* eslint-disable @typescript-eslint/no-magic-numbers */
    const { useLang, useToast, isPreRender, useUser } = require('@fegobull/webapi').use;
    const { useI18n } = require('@fegobull/webapi').use;
    const $tran = useI18n(locales_1.default);
    const { langText } = useLang();
    const Toast = useToast();
    const { uid } = useUser();
    const sentinelRef = (0, vue_demi_1.ref)(null); // 哨兵元素引用
    let observer = null; // IntersectionObserver 实例
    const inited = (0, vue_demi_1.ref)(false);
    const listData = (0, vue_demi_1.ref)([]);
    const cssVar = (0, vue_demi_1.ref)({});
    const props = __props;
    const LOADING_TIME = 10;
    const HUNDRED = 100;
    const TIME_LENGTH = 10;
    // 分页状态管理（游标分页）
    const PAGE_SIZE = 10;
    const pageSize = (0, vue_demi_1.ref)(PAGE_SIZE);
    const nextCursor = (0, vue_demi_1.ref)(null); // 下一页游标（上一页最后一条记录的ID）
    const hasMore = (0, vue_demi_1.ref)(true);
    const loading = (0, vue_demi_1.ref)(false);
    /**
     * 给用户名打马赛克
     */
    const maskNick = (nick) => {
        if (!nick) {
            return '';
        }
        if (nick.length < 4) {
            return nick;
        }
        return `${nick.slice(0, 2)}****${nick.slice(-2)}`;
    };
    /**
     * 去重函数 - 基于 uid + createTime
     */
    const removeDuplicates = newData => {
        const existingKeys = new Set(listData.value.map(item => `${item.uid}`));
        return newData.filter(item => {
            const key = `${item.uid}`;
            return !existingKeys.has(key);
        });
    };
    const initStyle = () => {
        cssVar.value = {
            '--background-color': props.backgroundColor,
            '--bg-border-color': props.bgBorderColor,
            '--line-color': props.lineColor,
            '--bg-border-radius': `${props.bgBorderRadius / HUNDRED}rem`
        };
    };
    /**
     * 加载邀请列表数据（游标分页）
     * @param cursor 游标（上一页最后一条记录的ID），不传则从最新数据开始
     * @param append 是否追加数据（后续分页时为 true）
     */
    const loadInviteData = async (cursor, append = false) => {
        if (loading.value) {
            return;
        }
        loading.value = true;
        try {
            if (!append) {
                Toast.loading(LOADING_TIME);
            }
            if (!props.actSign) {
                Toast.error($tran('fetch_fail'));
                return;
            }
            initStyle();
            // 构建请求参数
            const requestParams = {
                actSign: props.actSign,
                pageSize: pageSize.value,
                cursor
            };
            const res = await request_1.default.getRedpacketInviteList(requestParams);
            const { list, userProfiles, page: pageInfo } = res;
            const userProfileMap = {};
            // 更新用户资料映射表
            userProfiles.forEach(userProfile => {
                userProfileMap[userProfile.uid] = userProfile;
            });
            // 格式化列表数据
            const newList = list.map(item => {
                var _a, _b;
                return Object.assign(Object.assign({}, item), { createTime: item.createTime.slice(0, TIME_LENGTH), nick: maskNick(((_a = userProfileMap[item.uid]) === null || _a === void 0 ? void 0 : _a.nick) || ''), icon: ((_b = userProfileMap[item.uid]) === null || _b === void 0 ? void 0 : _b.icon) || '' });
            });
            // 去重后追加或替换数据
            const deduplicatedData = removeDuplicates(newList);
            if (append) {
                listData.value = [...listData.value, ...deduplicatedData];
            }
            else {
                listData.value = deduplicatedData;
            }
            // 更新下一页游标和是否有更多数据
            nextCursor.value = pageInfo.nextCursor;
            hasMore.value = pageInfo.hasMore;
            inited.value = true;
            if (!append) {
                Toast.close();
            }
        }
        catch (error) {
            Toast.error($tran('fetch_fail'));
            if (!append) {
                listData.value = [];
            }
            hasMore.value = false;
        }
        finally {
            loading.value = false;
        }
    };
    /**
     * 初始化 IntersectionObserver 监听哨兵元素
     * 当哨兵元素进入视口时，加载下一页数据
     */
    const initObserver = () => {
        if (observer) {
            observer.disconnect();
        }
        observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            // 哨兵元素进入视口且有更多数据时，加载下一页
            if (entry.isIntersecting && hasMore.value && !loading.value && nextCursor.value) {
                loadInviteData(nextCursor.value, true);
            }
        });
        if (sentinelRef.value) {
            observer.observe(sentinelRef.value);
        }
    };
    // 监听哨兵元素的变化，重新绑定 observer
    (0, vue_demi_1.watch)(sentinelRef, newVal => {
        if (newVal && observer) {
            observer.observe(newVal);
        }
    });
    (0, vue_demi_1.onMounted)(() => {
        // 预渲染不处理
        if (isPreRender) {
            return;
        }
        if (!uid) {
            return;
        }
        (0, vue_demi_1.nextTick)(() => {
            // 第一次加载不传 cursor
            loadInviteData(0, false);
            // 初始化 IntersectionObserver
            initObserver();
        });
    });
    (0, vue_demi_1.onUnmounted)(() => {
        // 清理 IntersectionObserver
        if (observer) {
            observer.disconnect();
            observer = null;
        }
    });
    return {
        $tran,
        langText,
        sentinelRef,
        inited,
        listData,
        cssVar
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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